import styled from "styled-components";

export var Wrapper = styled.article.withConfig({
  displayName: "atoms__Wrapper",
  componentId: "sc-1jdwryx-0"
})(["width:100%;border-radius:8px;margin-bottom:1rem;&:last-of-type{margin-bottom:0;}transition:background-color 200ms linear;background-color:", ";&.open{background-color:inherit;}"], function (props) {
  return props.theme.colors.ultraLightGrey;
});

export var Header = styled.div.withConfig({
  displayName: "atoms__Header",
  componentId: "sc-1jdwryx-1"
})(["padding-left:1.5rem;min-height:72px;display:flex;cursor:pointer;"]);

export var Question = styled.div.withConfig({
  displayName: "atoms__Question",
  componentId: "sc-1jdwryx-2"
})(["flex:1;margin:1.5rem 0;"]);

export var ExpandIcon = styled.div.withConfig({
  displayName: "atoms__ExpandIcon",
  componentId: "sc-1jdwryx-3"
})(["font-size:1.5rem;height:4.5rem;width:4.5rem;flex-shrink:0;color:", ";display:flex;justify-content:center;align-items:center;"], function (props) {
  return props.theme.primary;
});

export var Answer = styled.div.withConfig({
  displayName: "atoms__Answer",
  componentId: "sc-1jdwryx-4"
})(["padding:0 1.5rem 1.5rem;display:none;&.open{display:block;}"]);